<template>
  <div style="max-width: 1000px; margin: 0 auto;font-size:16px">
    <div style="margin-bottom: 10vh">
        <div v-html="$t('solution.desc1')" />
<div class="two-col-container">
        <img src="/statics/images/solution1.png" alt="" class="two-col" />
        <img src="/statics/images/solution2.png" alt="" class="two-col" />
      </div>
     </div>

    <div style="margin-bottom: 10vh">
        <div v-html="$t('solution.desc2')" />
      
      <img src="/statics/images/solution3.png" alt="" class="one-col" />
    </div>
    <div style="margin-bottom: 10vh">
        <div v-html="$t('solution.desc3')" />
      
      <img src="/statics/images/solution4.png" alt="" class="one-col" />
    </div>
    <div style="margin-bottom: 10vh">
        <div v-html="$t('solution.desc4')" />
      s
      <img src="/statics/images/solution5.png" alt="" class="one-col" />
    </div>
    <div style="margin-bottom: 10vh">
        <div v-html="$t('solution.desc5')" />
     
      <img src="/statics/images/solution6.png" alt="" class="one-col" />
      <div class="two-col-container">
        <img src="/statics/images/solution7.png" alt="" class="two-col" />
        <img src="/statics/images/solution8.png" alt="" class="two-col" />
      </div>
    </div>

    <div style="margin-bottom: 10vh">
        <div v-html="$t('solution.desc6')" />
      
      <img src="/statics/images/solution9.png" alt="" class="one-col" />
    </div>

    <div style="margin-bottom: 10vh">
        <div v-html="$t('solution.desc7')" />
      
      
      <img src="/statics/images/solution10.png" alt="" class="one-col" />
      <img src="/statics/images/solution11.png" alt="" class="one-col" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Cases",
  components: {},

  methods: {},
};
</script>

<style scoped>
.one-col {
  width: auto;
  max-width: 90%;
  min-width: 250px;
  max-height: 60vh;
  margin: 20px auto;
  object-fit: contain;
  display: flex;
}
.two-col-container {
  width: auto;
  height: auto;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.two-col {
  width: auto;
  max-width: 40%;
  min-width: 250px;
  max-height: 60vh;
  object-fit: contain;
}
</style>
